<template>
  <div class="container-fluid">
    <b-card no-body class="calendarDoorderCard p-3">
      <b-row>
        <b-col lg="2" md="3" class="px-1">
          <div id="filterByStatusDiv" class="calendarFilterDiv">
            <h3 class="calendarFilterH3">Filter by status</h3>

            <b-form-group class="w-100" label-class="px-1">
              <template #label>
                <b-form-checkbox
                  v-model="selectAllStatus"
                  class="
                    form-check-filter-doorder
                    calendarFilter
                    allStatusFilterCheckbox
                    mb-1
                  "
                  :indeterminate="indeterminateStatus"
                  @change="toggleAllStatus"
                >
                  View all
                </b-form-checkbox>
              </template>
              <b-form-checkbox-group
                v-model="filterByStatus"
                class="px-1 row w-100 m-0"
                name="filterByStatus"
                stacked
              >
                <b-form-checkbox
                  v-for="option in status_options"
                  :key="option.value"
                  class="
                    form-check-filter-doorder
                    calendarFilter
                    mb-1
                    col-6 col-md-12
                  "
                  :class="option.value + '-statusFilterCheckbox'"
                  :value="option.value"
                  >{{ option.text }}</b-form-checkbox
                >
              </b-form-checkbox-group>
            </b-form-group>
          </div>
          <div id="filterByRetailerDiv" class="calendarFilterDiv">
            <h3 class="calendarFilterH3">Filter by retailer</h3>

            <b-form-group
              class="w-100 scrollRetailerFilterDoorder"
              label-class="px-1"
            >
              <template #label>
                <b-form-checkbox
                  v-model="selectAllRetailer"
                  class="
                    form-check-filter-doorder
                    calendarFilter
                    allRetailerFilterCheckbox
                    mb-1
                  "
                  :indeterminate="indeterminateRetailer"
                  @change="toggleAllRetailer"
                >
                  View all
                </b-form-checkbox>
              </template>
              <b-form-checkbox-group
                v-model="filterByRetailer"
                class="px-1 row w-100 m-0"
                name="filterByRetailer"
                stacked
              >
                <b-form-checkbox
                  v-for="option in retailers_options"
                  :key="option.id"
                  class="
                    form-check-filter-doorder
                    calendarFilter
                    retailer-FilterCheckbox
                    mb-1
                    col-6 col-md-12
                  "
                  :value="option.id"
                  >{{ option.name }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col lg="10" md="9" class="pl-0">
          <FullCalendar
            ref="calendarOrders"
            :options="calendarOptions"
            :eventsources="calendarOptions.eventSources"
            :config="config"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>


<script>
import $ from "jquery";
import axios from "axios";

import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import moment from "moment";

export default {
  name: "DoorderOrdersCalendar",
  components: { FullCalendar },
  data() {
    let tempvue = this;
    return {
      user_title: JSON.parse(window.localStorage.getItem("user")),
      status_options: [
        { text: "Pending fullfilment", value: "pending" },
        { text: "Ready to Collect", value: "ready" },
        { text: "Matched", value: "matched" },
        { text: "On-route to Pickup", value: "on_route_pickup" },
        { text: "Picked up", value: "picked_up" },
        { text: "Arrived at pickup", value: "arrived_at_pickedup" },
        { text: "On-route", value: "on_route" },
        { text: "Arrived to location", value: "delivery_arrived" },
        { text: "Delivered", value: "delivered" },
        { text: "Not delivered", value: "not_delivered" },
      ],
      filterByStatus: [],
      selectAllStatus: true,
      indeterminateStatus: false,

      retailers_options: [],
      filterByRetailer: [],
      selectAllRetailer: true,
      indeterminateRetailer: false,

      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        // displayEventTime: true,
        headerToolbar: {
          // left: 'title',
          // left:'prev title next',
          // center: 'agendaDay,agendaWeek,month,agendaYear',
          // right:'today',
          left: "prev next title",
          center: "",
          right: "dayGridMonth,timeGridWeek,timeGridDay today",
          // center: 'agendaDay,agendaWeek,month',
          // right: 'prev,next today'
        },
        eventLimit: true,
        eventorder: "-title",
        dayMaxEvents: 3,
        firstDay: 1,
        responsive: false,
        contentHeight: "auto",
        // Dynamic Event Source
        eventSources: [
          {
            events(start, callback) {
              // console.log(start.start, start.end);
              // console.log(axios.defaults.baseURL);
              let formData = new FormData();
              formData.append("from", start.start);
              formData.append("to", start.end);
              axios
                .get(
                  "jobs/calendar?from=" +
                    moment(start.start).format("yyyy-MM-DD") +
                    "&to=" +
                    moment(start.end).format("yyyy-MM-DD"),
                  {
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      client: "DOORDER",
                      Authorization:
                        "Bearer " +
                        JSON.parse(window.localStorage.getItem("user"))
                          .access_token,
                    },
                  }
                )
                .then((response) => {
                  console.log(response);
                  let events = response.data;
                  // let events = [
                  //   {
                  //     id: 1,
                  //     title: "Retailer 1",
                  //     start: "2022-12-06",
                  //     className: "pending_status",
                  //     retailer_id: 1,
                  //     status: "pending",
                  //   },
                  //   {
                  //     id: 1,
                  //     title: "Retailer 1",
                  //     start: "2022-12-02",
                  //     className: "ready_status",
                  //     retailer_id: 1,
                  //     status: "ready",
                  //   },
                  //   {
                  //     id: 1,
                  //     title: "Retailer 1",
                  //     start: "2022-12-03",
                  //     className: "matched_status",
                  //     retailer_id: 1,
                  //     status: "matched",
                  //   },
                  //   {
                  //     id: 1,
                  //     title: "Retailer 1",
                  //     start: "2022-12-05",
                  //     className: "assigned_status",
                  //     retailer_id: 1,
                  //     status: "assigned",
                  //   },
                  //   {
                  //     id: 1,
                  //     title: "Retailer 1",
                  //     start: "2022-12-10",
                  //     className: "on_route_pickup_status",
                  //     retailer_id: 1,
                  //     status: "on_route_pickup",
                  //   },
                  //   {
                  //     id: 1,
                  //     title: "Retailer 1",
                  //     start: "2022-12-22",
                  //     className: "picked_up_status",
                  //     retailer_id: 1,
                  //     status: "picked_up",
                  //   },
                  //   {
                  //     id: 1,
                  //     title: "Retailer 1",
                  //     start: "2022-12-03",
                  //     className: "arrived_at_pickedup_status",
                  //     retailer_id: 1,
                  //     status: "arrived_at_pickedup",
                  //   },
                  //   {
                  //     id: 1,
                  //     title: "Retailer 1 sadsfds dsasfds",
                  //     start: "2022-12-05",
                  //     className: "on_route_status",
                  //     retailer_id: 1,
                  //     status: "on_route",
                  //   },
                  //   {
                  //     id: 1,
                  //     title: "Retailer 1",
                  //     start: "2022-12-12",
                  //     className: "delivery_arrived_status",
                  //     retailer_id: 1,
                  //     status: "delivery_arrived",
                  //   },
                  //   {
                  //     id: 1,
                  //     title: "Retailer 2",
                  //     start: "2022-12-12",
                  //     className: "delivered_status",
                  //     retailer_id: 1,
                  //     status: "delivered",
                  //   },
                  //   {
                  //     id: 1,
                  //     title: "Retailer 1",
                  //     start: "2022-12-12",
                  //     className: "not_delivered_status",
                  //     retailer_id: 1,
                  //     status: "not_delivered",
                  //   },
                  // ];
                  for (let i = events.length - 1; i >= 0; i--) {
                    // console.log(
                    //   "====>",
                    //   i,
                    //   events.length,
                    //   tempvue.filter(events[i])
                    // );
                    // console.log(events);
                    if (!tempvue.filter(events[i])) {
                      if (events.length <= 1) {
                        events = [];
                      } else {
                        events.splice(i, 1);
                      }
                    }
                    // console.log(tempvue.user_title)
                    // console.log(tempvue.filter(events[i]))
                  }
                  // console.log(events);
                  callback(events);
                })
                .catch((error) => {
                  console.log(error)
                  // console.log(error.response.data.error);
                  // console.log(error.request);
                  // console.log(error.message);
                  // this.$fire({
                  //   // title: "Title",
                  //   text: error.response.data.error,
                  //   type: "error",
                  //   // timer: 5000,
                  // }).then((r) => {
                  //   // console.log(r.value);
                  // });
                  // this.loginErrorMessage = error.response.data.error;
                  // this.showLoginErrorMessage = true;
                });
            },
          },
        ],
        eventDidMount: function (info) {},
        refetchEvents: function (info) {
          // console.log("===============>>>>>>>>>>>");
          // console.log(info);
        },
        events: [],
        eventClick: (event) => {
          // console.log("event");
          // console.log(event);
        },
      },
      config: {
        eventClick: (event) => {
          // console.log(event);
        },
      },
    };
  },

  mounted() {
    let user = JSON.parse(window.localStorage.getItem("user"));
    // console.log(user);
    // console.log(user.id, user.title);
    this.user_id = user.id;
    this.user_title = user.type;
    // console.log(this.user_title);
    // console.log(this.user_title);

    this.getAcceptedRetaailers();

    this.toggleAllStatus(true);
  },
  watch: {
    filterByStatus(newValue, oldValue) {
      // console.log(newValue);
      // console.log(oldValue);
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminateStatus = false;
        this.selectAllStatus = false;
      } else if (newValue.length === this.status_options.length) {
        this.indeterminateStatus = false;
        this.selectAllStatus = true;
      } else {
        this.indeterminateStatus = true;
        this.selectAllStatus = false;
      }
      let calendar = this.$refs.calendarOrders.getApi();
      // console.log(calendar);
      calendar.refetchEvents();
    },
    filterByRetailer(newValue, oldValue) {
      // console.log(newValue);
      // console.log(oldValue);
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminateRetailer = false;
        this.selectAllRetailer = false;
      } else if (newValue.length === this.retailers_options.length) {
        this.indeterminateRetailer = false;
        this.selectAllRetailer = true;
      } else {
        this.indeterminateRetailer = true;
        this.selectAllRetailer = false;
      }
      let calendar = this.$refs.calendarOrders.getApi();
      // console.log(calendar);
      calendar.refetchEvents();
    },
  },
  methods: {
    getAcceptedRetaailers() {
      // console.log("here call user list");
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token);
      axios
        .get("/retailer/accepted-list", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DOORDER",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.retailers_options = response.data;
          // console.log(this.rowsData);

          this.toggleAllRetailer(true);
        });
    },
    toggleAllStatus(checked) {
      let all_status = [];
      for (let i = 0; i < this.status_options.length; i++) {
        all_status.push(this.status_options[i].value);
      }
      this.filterByStatus = checked ? all_status : [];
    },
    toggleAllRetailer(checked) {
      let all_retailers = [];
      for (let i = 0; i < this.retailers_options.length; i++) {
        all_retailers.push(this.retailers_options[i].id);
      }
      this.filterByRetailer = checked ? all_retailers : [];
    },
    filter(event) {
      // console.log("filter ----- ");
      // console.log(event);
      var vals = this.filterByStatus;
      // $('input[name="filterByStatus"]:checked').each(function () {
      //   vals.push($(this).val());
      // });

      if (event.status === "assigned") {
        event.status = "matched";
      }

      var valsR = this.filterByRetailer;
      // $('input[name="filterByRetailer"]:checked').each(function () {
      //   valsR.push($(this).val());
      // });

      // console.log(vals);
      // console.log(valsR);
      if (this.selectAllStatus && this.selectAllRetailer) {
        return true;
      } else if (
        this.selectAllStatus &&
        valsR.indexOf(event.retailer_id) !== -1
      ) {
        return true;
      } else if (this.selectAllRetailer && vals.indexOf(event.status) !== -1) {
        return true;
      }
      return (
        vals.indexOf(event.status) !== -1 &&
        valsR.indexOf(event.retailer_id) !== -1
      );
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/orders/lists/CalendarView.vue